<div class="unauthorized_wrappar" id="vi_unauthorized_wrappar">
  <!-- <div class="img-wrappar"><img src="../../assets/unauthorized.svg" /></div> -->
  <h3 class="no-access">Unsubscribed</h3>
  <p class="message-1">{{ email_text }}</p>
</div>
